module.exports = __webpack_public_path__ + "static/media/kidsFaqBackground.96308cdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/KidsFaq/kidsFaqBackground.svg
// module id = 899
// module chunks = 0